import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors/ui';

/** @returns {number} */
export const getUnreadNotificationsCount = createSelector(getParent, ({ unreadIds }) => unreadIds.size);
